import { useQuery } from '@tanstack/react-query';
import type { SiestaSkill } from '../types';

export default function useTenantSkill(skillId: string | null) {
  return useQuery<SiestaSkill>({
    queryKey: ['tenant', 'custom-skills', skillId],
    enabled: skillId !== null,
  });
}
